import React, { useEffect, useRef, useState } from "react";
import { Form, Spin, Select, Modal, DatePicker, Input, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Dragger from "antd/es/upload/Dragger";
import { saveFileUpload } from "../../features/save/saveSlice"; 
import datasetSvg from "../../assets/svg/svg14.svg";

const url = process.env.REACT_APP_API_BASE_URL;
const DocumentTableAdd = ({ isModalOpen, handleCancel, handleFetch,prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [fileUrl, setfileUrl] = useState("");
  const [fileName, setfileName] = useState("");
  const [fileLoading, setFileLoading] = useState(false);

  const props = {
    name: "file",
    multiple: false,
    accept:".xls,.xlsx,application/pdf",
    showUploadList: true,

    beforeUpload: (file) => {
      setFileLoading(true);
      setfileUrl(file);
      setfileName(file.name);
      setFileLoading(false);

      return false;
    },

    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const onFinish = async () => {
    if (!fileUrl) {
      toast.error("Please upload file");
      return;
    }
    const formData = new FormData();
    formData.append("file", fileUrl);
    const res = await dispatch(
      saveFileUpload({
        url: `api/v1/files?td_id=${prodd?.tdId}`,
        formData,
      })
    ).unwrap(); 
    if (res?.success) {
      await toast.success(res?.messages?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.messages?.message);
    }
  };

  return (
    <Modal
      title={
        <div className="flex gap-[1.25rem] mb-[1.25rem]">
          <div className="rounded-[.25rem] bg-[#D6E1F5] h-[3rem] w-[3rem] flex items-center justify-center">
            <img src={datasetSvg} alt="datasetSvg" />
          </div>
          <div className="flex flex-col ">
            <span className="typography_3">Upload Document</span>
            <span className="typography">
               Upload excel or csv or pdf document to populate your dataset
            </span>
          </div>
        </div>
      }
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[49.5rem]"
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      > 
        <Form.Item
          name=""
          label="Document File"
          rules={[
            {
              required: true,
              message: "Please upload a file",
            },
          ]}
        >
          <Dragger className="attachment" {...props}>
            <div className="flex flex-col justify-center">
              <div className="flex justify-center mb-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <path
                    d="M25.375 18.125V22.9583C25.375 23.5993 25.1204 24.214 24.6672 24.6672C24.214 25.1204 23.5993 25.375 22.9583 25.375H6.04167C5.40073 25.375 4.78604 25.1204 4.33283 24.6672C3.87961 24.214 3.625 23.5993 3.625 22.9583V18.125"
                    stroke="#147CBC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20.5423 9.66667L14.5007 3.625L8.45898 9.66667"
                    stroke="#147CBC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.5 3.625V18.125"
                    stroke="#147CBC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <p className="ant-upload-text !ml-2">
                Click to upload
                <span className="ml-2 text-[#667085]">or drag and drop</span>
                <br></br>
                <span className="!mt-[10rem] text-[#667085]">
                  EXCEL or CSV or PDF
                </span>
              </p>
            </div>
          </Dragger>
        </Form.Item>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? <Spin /> : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default DocumentTableAdd;
